import React, { useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { scrollTop } from "../../utils/window";
import { DOST_PROGRAM } from "../../constant";
import Labels from "../../services/apiLabels";
import { POST } from "../../constant/apiMethods";
import PuffLoader from "react-spinners/ClipLoader";
import { useContext } from "react";
import FeedbackContext from "../../context/cmscontext";
import {
  HiOutlineUser,
  HiOutlineMail,
  HiOutlineLocationMarker,
  HiOutlinePhone,
  HiOutlineArrowRight,
  HiOutlineGift,
  HiOutlineUserGroup,
  HiOutlineCash,
  HiOutlineDuplicate,
  HiOutlineOfficeBuilding,
  HiOutlineUserCircle,
  HiOutlineShare,
  HiOutlineCheckCircle,
} from "react-icons/hi";
import { buildReferralUrl, getAuthToken } from "../../utils/userIdentity";

const publicUrl = process.env.PUBLIC_URL || "";

function DostProgram({ dostProgramSignUp, dost_loading, auth }) {
  const { feedback } = useContext(FeedbackContext);
  const dost_program = feedback.dost_program || {};
  const isLoggedIn = Boolean(getAuthToken(auth));
  const referralUrl = useMemo(() => buildReferralUrl(auth), [auth]);
  const [copied, setCopied] = useState(false);

  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [postcode, setPostcode] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [mobileNo, setMobileNo] = useState("");

  useEffect(() => {
    scrollTop();
  }, []);

  const submitHandler = (e) => {
    e.preventDefault();
    if (dost_loading) return;

    const data = {
      name: fullName,
      email: email,
      postcode: postcode,
      state: state,
      city: city,
      mobile_number: mobileNo,
    };

    dostProgramSignUp(data);
  };

  const copyReferralUrl = async () => {
    if (!referralUrl) return;
    try {
      await navigator.clipboard.writeText(referralUrl);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      setCopied(false);
    }
  };

  const rewardRows = [
    { value: dost_program.up_to_2_million, reward: dost_program.Rs_15000 },
    { value: dost_program.up_to_4_million, reward: dost_program.Rs_20000 },
    { value: dost_program.above_4_million, reward: dost_program.Rs_25000 },
  ];

  const steps = [
    {
      title: dost_program.Step_1_text,
      description: dost_program.Step_1_desp,
      image: `${publicUrl}/images/dost-step-1.jpg`,
    },
    {
      title: dost_program.Step_2_text,
      description: dost_program.Step_2_desp,
      image: `${publicUrl}/images/dost-step-2.jpg`,
    },
    {
      title: dost_program.Step_3_text,
      description: dost_program.Step_3_desp,
      image: `${publicUrl}/images/dost-step-3.jpg`,
    },
  ];

  const terms = [
    dost_program.Your_mobile_number,
    dost_program.SellAnyWheel_can_reject,
    dost_program.SellAnyWheel_can_cancel,
    dost_program.Register_to_learn,
    dost_program.SellAnyWheel_Dost_Program_Rewards,
  ];

  const creditPoints = [
    {
      title: "Credits land in wallets",
      body: "Successful referrals add credits to account wallets—ready to use toward eligible AutoTrade Port services.",
      Icon: HiOutlineCash,
    },
    {
      title: "Client & dealer wallets",
      body: "Credits are credited to both client wallets and dealer wallets, depending on who is part of the referral.",
      Icon: HiOutlineOfficeBuilding,
    },
    {
      title: "Sender and receiver both earn",
      body: "When a referral converts, the person who shared the link and the person who joined both receive credits.",
      Icon: HiOutlineShare,
    },
  ];

  const walletCards = [
    {
      title: "Client wallet",
      body: "Sellers and buyers earn referral credits in their client wallet after a successful referral.",
      Icon: HiOutlineUserCircle,
      points: [
        "Credits appear on your account balance",
        "Track them anytime under Credit info",
        "Use toward eligible client services",
      ],
    },
    {
      title: "Dealer wallet",
      body: "Dealers also receive referral credits in their dealer wallet when they are part of a successful referral.",
      Icon: HiOutlineOfficeBuilding,
      points: [
        "Credits post to the dealer wallet",
        "Visible in dealer account balances",
        "Supports dealer-side rewards and usage",
      ],
    },
  ];

  const earnSides = [
    {
      role: "Sender",
      title: "You share your referral",
      body: "Share your unique referral link or code. When someone uses it and completes a qualifying action, credits are added to your wallet.",
      Icon: HiOutlineShare,
    },
    {
      role: "Receiver",
      title: "Your friend joins",
      body: "The person who signs up or books with your referral also receives credits in their wallet—so both sides benefit.",
      Icon: HiOutlineGift,
    },
  ];

  const howSteps = [
    {
      num: "01",
      title: "Get your link",
      body: "Sign in and copy your personal referral URL.",
      Icon: HiOutlineDuplicate,
    },
    {
      num: "02",
      title: "Share it",
      body: "Send the link to friends, clients, or dealers.",
      Icon: HiOutlineShare,
    },
    {
      num: "03",
      title: "Both earn credits",
      body: "Sender and receiver get credits in their wallets.",
      Icon: HiOutlineCash,
    },
  ];

  return (
    <div className="pi-dost">
      <header className="pi-inner-hero pi-dost__hero">
        <div className="pi-inner-hero__media" aria-hidden="true">
          <img
            className="pi-inner-hero__media-img pi-dost__hero-img"
            src={`${publicUrl}/images/dost-hero.jpg`}
            alt=""
          />
          <span className="pi-inner-hero__media-shade" />
          <span className="pi-dost__hero-shimmer" aria-hidden="true" />
        </div>
        <div className="pi-inner-hero__fx" aria-hidden="true">
          <span className="pi-inner-hero__glow pi-inner-hero__glow--a pi-dost__orb pi-dost__orb--a" />
          <span className="pi-inner-hero__glow pi-inner-hero__glow--b pi-dost__orb pi-dost__orb--b" />
          <span className="pi-inner-hero__grid" />
        </div>
        <div className="pi-inner-hero__content pi-dost__hero-content">
          <div className="pi-inner-hero__copy pi-dost__reveal pi-dost__reveal--1">
            <p className="pi-label pi-inner-hero__label">Referral</p>
            <h1 className="pi-inner-hero__title">Referral</h1>
            <p className="pi-inner-hero__lead">
              Share AutoTrade Port, grow your network, and earn wallet credits—
              for you and the person you refer.
            </p>
          </div>
        </div>
        <span className="pi-inner-hero__fade" aria-hidden="true" />
      </header>

      <div className="pi-dost__body">
        <div className="pi-dost__body-fx" aria-hidden="true">
          <span className="pi-dost__body-glow pi-dost__body-glow--a" />
          <span className="pi-dost__body-glow pi-dost__body-glow--b" />
        </div>
        <div className="pi-dost__inner">
          {/* ── New Referral / Credits sections ── */}
          <section
            className="pi-referral-credits pi-dost__reveal pi-dost__reveal--2"
            aria-labelledby="referral-credits-heading"
          >
            <div className="pi-section-head">
              <p className="pi-label">Credits</p>
              <h2 id="referral-credits-heading">How referral credits work</h2>
              <p className="pi-referral-credits__lead">
                Every successful referral adds credits to wallets. Credits can
                land in a client wallet or a dealer wallet, and both the sender
                and the receiver earn when a referral completes.
              </p>
            </div>

            <div className="pi-referral-credits__grid">
              {creditPoints.map((item) => (
                <article key={item.title} className="pi-referral-credits__card">
                  <span className="pi-referral-credits__icon" aria-hidden>
                    <item.Icon size={22} />
                  </span>
                  <h3>{item.title}</h3>
                  <p>{item.body}</p>
                </article>
              ))}
            </div>
          </section>

          <section
            className="pi-referral-wallets pi-dost__reveal pi-dost__reveal--3"
            aria-labelledby="referral-wallets-heading"
          >
            <div className="pi-section-head">
              <p className="pi-label">Wallets</p>
              <h2 id="referral-wallets-heading">Client and dealer wallets</h2>
              <p className="pi-referral-credits__lead">
                Credits are stored in the right wallet for your account type.
                Clients and dealers each keep a separate balance.
              </p>
            </div>

            <div className="pi-referral-wallets__grid">
              {walletCards.map((card) => (
                <article key={card.title} className="pi-referral-wallets__card">
                  <header className="pi-referral-wallets__head">
                    <span className="pi-referral-wallets__icon" aria-hidden>
                      <card.Icon size={24} />
                    </span>
                    <h3>{card.title}</h3>
                  </header>
                  <p>{card.body}</p>
                  <ul className="pi-referral-wallets__list">
                    {card.points.map((point) => (
                      <li key={point}>
                        <HiOutlineCheckCircle size={16} aria-hidden />
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                </article>
              ))}
            </div>
          </section>

          <section
            className="pi-referral-earn pi-dost__reveal pi-dost__reveal--4"
            aria-labelledby="referral-earn-heading"
          >
            <div className="pi-section-head">
              <p className="pi-label">Earn together</p>
              <h2 id="referral-earn-heading">Sender and receiver both get credits</h2>
              <p className="pi-referral-credits__lead">
                Referral rewards are two-sided. Share a link, and when it
                converts, credits go to both wallets involved.
              </p>
            </div>

            <div className="pi-referral-earn__grid">
              {earnSides.map((side) => (
                <article key={side.role} className="pi-referral-earn__card">
                  <span className="pi-referral-earn__role">{side.role}</span>
                  <span className="pi-referral-earn__icon" aria-hidden>
                    <side.Icon size={26} />
                  </span>
                  <h3>{side.title}</h3>
                  <p>{side.body}</p>
                </article>
              ))}
            </div>

            <div className="pi-referral-earn__flow" aria-hidden="true">
              <span>Sender</span>
              <span className="pi-referral-earn__flow-line" />
              <HiOutlineGift size={18} />
              <span className="pi-referral-earn__flow-line" />
              <span>Receiver</span>
            </div>
          </section>

          <section
            className="pi-referral-how"
            aria-labelledby="referral-how-heading"
          >
            <div className="pi-section-head">
              <p className="pi-label">How it works</p>
              <h2 id="referral-how-heading">Three steps to earn credits</h2>
              <p className="pi-referral-credits__lead">
                Share once. When the referral succeeds, credits go to both sides.
              </p>
            </div>

            <div className="pi-referral-how__grid">
              {howSteps.map((step) => (
                <article key={step.num} className="pi-referral-how__card">
                  <div className="pi-referral-how__top">
                    <span className="pi-referral-how__icon" aria-hidden>
                      <step.Icon size={20} />
                    </span>
                    <span className="pi-referral-how__num">{step.num}</span>
                  </div>
                  <h3 className="pi-referral-how__title">{step.title}</h3>
                  <p className="pi-referral-how__text">{step.body}</p>
                </article>
              ))}
            </div>
          </section>

          <section
            className="pi-referral-cta"
            aria-labelledby="referral-cta-heading"
          >
            <div className="pi-referral-cta__card">
              <div className="pi-referral-cta__copy">
                <p className="pi-label">Your link</p>
                <h2 id="referral-cta-heading">Share your referral URL</h2>
                <p>
                  {isLoggedIn
                    ? "Copy your personal referral link and share it. Credits will be added to the matching wallets when referrals succeed."
                    : "Sign in to get your personal referral link, then share it to start earning credits with friends and dealers."}
                </p>
              </div>

              {isLoggedIn ? (
                <div className="pi-referral-cta__actions">
                  <div className="pi-referral-cta__url">
                    <input readOnly value={referralUrl} aria-label="Referral URL" />
                    <button type="button" onClick={copyReferralUrl}>
                      <HiOutlineDuplicate size={18} aria-hidden />
                      {copied ? "Copied" : "Copy"}
                    </button>
                  </div>
                  <div className="pi-referral-cta__links">
                    <Link to="/credits" className="pi-referral-cta__secondary">
                      View credit info
                    </Link>
                    <Link to="/referral" className="pi-referral-cta__secondary">
                      Manage referral URL
                    </Link>
                  </div>
                </div>
              ) : (
                <div className="pi-referral-cta__actions">
                  <Link to="/login" className="pi-referral-cta__primary">
                    Sign in to get your link
                    <HiOutlineArrowRight size={18} aria-hidden />
                  </Link>
                </div>
              )}
            </div>
          </section>

          {/* ── Legacy Dost Program sections (hidden) ── */}
          <div className="pi-dost__legacy" hidden aria-hidden="true">
            <div className="pi-dost__layout">
              <section
                className="pi-dost__info pi-dost__reveal pi-dost__reveal--2"
                aria-labelledby="dost-rewards-heading"
              >
                <div className="pi-dost__info-card">
                  <p className="pi-label">Rewards</p>
                  <h2 id="dost-rewards-heading">{dost_program.Value_of_car}</h2>
                  <p className="pi-dost__info-lead">{dost_program.Refer_your_friends}</p>
                  <div className="pi-dost__table-wrap">
                    <table className="pi-dost__table">
                      <thead>
                        <tr>
                          <th>{dost_program.Value_of_car}</th>
                          <th>{dost_program.Reward_}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rewardRows.map((row, index) => (
                          <tr
                            key={row.value}
                            className="pi-dost__table-row"
                            style={{ animationDelay: `${0.15 + index * 0.08}s` }}
                          >
                            <td>{row.value}</td>
                            <td>
                              <span className="pi-dost__reward-pill">{row.reward}</span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <div className="pi-dost__visual">
                    <span className="pi-dost__visual-accent" aria-hidden="true" />
                    <div className="pi-dost__visual-media">
                      <span className="pi-dost__visual-grid" aria-hidden="true" />
                      <span className="pi-dost__visual-shine" aria-hidden="true" />
                      <img
                        src={`${publicUrl}/images/dost-referral.jpg`}
                        alt="Successful car referral handshake at a premium dealership"
                      />
                      <div className="pi-dost__visual-caption">
                        <span className="pi-dost__visual-tag">
                          <HiOutlineUserGroup size={14} aria-hidden />
                          Refer &amp; earn
                        </span>
                        <p>{dost_program.Step_3_desp}</p>
                      </div>
                      <div className="pi-dost__visual-chips" aria-hidden="true">
                        {rewardRows.map((row, index) => (
                          <span
                            key={row.reward}
                            className="pi-dost__visual-chip"
                            style={{ animationDelay: `${0.4 + index * 0.35}s` }}
                          >
                            {row.reward.trim()}
                          </span>
                        ))}
                      </div>
                    </div>
                    <aside
                      className="pi-dost__visual-badge"
                      aria-label={`Maximum reward ${String(
                        dost_program.Rs_25000 || ""
                      ).trim()}`}
                    >
                      <span className="pi-dost__visual-badge-icon" aria-hidden>
                        <HiOutlineGift size={20} />
                      </span>
                      <span className="pi-dost__visual-badge-label">
                        {dost_program.Reward_}
                      </span>
                      <strong>{String(dost_program.Rs_25000 || "").trim()}</strong>
                      <small>Top tier payout</small>
                    </aside>
                  </div>
                </div>
              </section>

              <section
                className="pi-dost__signup pi-dost__reveal pi-dost__reveal--3"
                aria-labelledby="dost-form-heading"
              >
                <div className="pi-dost__form-card">
                  <span className="pi-dost__form-glow" aria-hidden="true" />
                  <div className="pi-dost__form-head">
                    <p className="pi-label">Join us</p>
                    <h2 id="dost-form-heading">{dost_program.Join_the_Dost_Army}</h2>
                  </div>

                  <form onSubmit={submitHandler} className="pi-dost__form">
                    <label className="pi-dost__field">
                      <span className="pi-dost__field-icon" aria-hidden>
                        <HiOutlineUser size={18} />
                      </span>
                      <input
                        type="text"
                        name="fullname"
                        required
                        className="pi-dost__input"
                        placeholder={dost_program.Name_placeholder}
                        onChange={(e) => setFullName(e.target.value)}
                        disabled={dost_loading}
                      />
                    </label>
                    <label className="pi-dost__field">
                      <span className="pi-dost__field-icon" aria-hidden>
                        <HiOutlineMail size={18} />
                      </span>
                      <input
                        type="email"
                        name="email"
                        required
                        className="pi-dost__input"
                        placeholder={dost_program.Email_placeholder}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={dost_loading}
                      />
                    </label>
                    <label className="pi-dost__field">
                      <span className="pi-dost__field-icon" aria-hidden>
                        <HiOutlineLocationMarker size={18} />
                      </span>
                      <input
                        type="text"
                        name="postcode"
                        required
                        className="pi-dost__input"
                        placeholder={dost_program.Postcode_placeholder}
                        onChange={(e) => setPostcode(e.target.value)}
                        disabled={dost_loading}
                      />
                    </label>
                    <div className="pi-dost__field-row">
                      <label className="pi-dost__field">
                        <span className="pi-dost__field-icon" aria-hidden>
                          <HiOutlineLocationMarker size={18} />
                        </span>
                        <input
                          type="text"
                          name="state"
                          required
                          className="pi-dost__input"
                          placeholder={dost_program.State_placeholder}
                          onChange={(e) => setState(e.target.value)}
                          disabled={dost_loading}
                        />
                      </label>
                      <label className="pi-dost__field">
                        <span className="pi-dost__field-icon" aria-hidden>
                          <HiOutlineLocationMarker size={18} />
                        </span>
                        <input
                          type="text"
                          name="city"
                          required
                          className="pi-dost__input"
                          placeholder={dost_program.City_Name_placeholder}
                          onChange={(e) => setCity(e.target.value)}
                          disabled={dost_loading}
                        />
                      </label>
                    </div>
                    <label className="pi-dost__field">
                      <span className="pi-dost__field-icon" aria-hidden>
                        <HiOutlinePhone size={18} />
                      </span>
                      <input
                        type="text"
                        name="mobile"
                        id="mobile"
                        required
                        className="pi-dost__input"
                        placeholder={dost_program.Mobile_No_placeholder}
                        onChange={(e) => setMobileNo(e.target.value)}
                        disabled={dost_loading}
                      />
                    </label>

                    <ol className="pi-dost__terms-list">
                      {terms.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ol>

                    <label className="pi-dost__checkbox">
                      <input
                        type="checkbox"
                        name="termsConditions"
                        id="termsConditions"
                        disabled={dost_loading}
                      />
                      <span className="pi-dost__checkbox-mark" aria-hidden />
                      <span>{dost_program.Terms_and_Conditions_text}</span>
                    </label>

                    <button
                      type="submit"
                      className="pi-dost__submit"
                      name="CTAButton"
                      disabled={dost_loading}
                    >
                      {dost_loading ? (
                        <PuffLoader size={15} color="#ffffff" />
                      ) : (
                        <>
                          {dost_program.SignUp_button_text}
                          <HiOutlineArrowRight size={18} aria-hidden />
                        </>
                      )}
                    </button>
                  </form>
                </div>
              </section>
            </div>

            <section
              className="pi-dost__steps pi-dost__reveal pi-dost__reveal--4"
              aria-labelledby="dost-steps-heading"
            >
              <div className="pi-section-head">
                <p className="pi-label">Process</p>
                <h2 id="dost-steps-heading">{dost_program.How_It_Works_text}</h2>
              </div>
              <div className="pi-dost__steps-grid">
                {steps.map((step, index) => (
                  <article
                    key={step.title}
                    className="pi-dost__step"
                    style={{ animationDelay: `${0.2 + index * 0.12}s` }}
                  >
                    <div className="pi-dost__step-media">
                      <img src={step.image} alt="" />
                      <span className="pi-dost__step-media-shade" aria-hidden />
                      <span className="pi-dost__step-num" aria-hidden>
                        {String(index + 1).padStart(2, "0")}
                      </span>
                    </div>
                    <div className="pi-dost__step-body">
                      <h3>{step.title}</h3>
                      <p>{step.description}</p>
                    </div>
                  </article>
                ))}
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  dost_loading: state.cardeailupdate.dost_loading,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  dostProgramSignUp: (data) =>
    dispatch({
      type: DOST_PROGRAM,
      payload: {
        type: DOST_PROGRAM,
        label: Labels.dost_program,
        method: POST,
        data,
        hideOverlayLoader: true,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(DostProgram);
